// src/custom/DefaultViewWithoutTitle.jsx
import React from 'react';
import DefaultView from '@plone/volto/components/theme/View/DefaultView';

const DefaultViewWithoutTitle = (props) => {
  const { content } = props;

  // Keep people_preview blocks out of the rendered page
  const blocks = content?.blocks || {};
  const blocksLayout = content?.blocks_layout?.items || [];

  const filteredBlocksLayout = blocksLayout.filter((blockId) => {
    const blockType = blocks?.[blockId]?.['@type'];
    // Drop the people_preview and title blocks
    return blockType !== 'people_preview' && blockType !== 'title';
  });

  const modifiedContent = {
    ...content,
    blocks_layout: {
      ...content?.blocks_layout,
      items: filteredBlocksLayout,
    },
  };

  return <DefaultView {...props} content={modifiedContent} />;
};

export default DefaultViewWithoutTitle;
